<template>
  <input id="my-file" type="file" name="my-file" style="display: none" />

  <editor
    api-key="f536kduwtjx4cdnvdlyreiw732soeeloiv4zu436uat6t9u7"
    @input="updateValue($event.target.value)"
    v-model="this.editorContent"
    :init="myInit"
  />
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "editorComponent",
  data() {
    return {
      editorContent: "",
      myInit: {
        height: this.height,
        selector: "textarea", // change this value according to your HTML
        file_picker_type: true,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: "image",

        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype == "image") {
            var input = document.getElementById("my-file");
            input.click();
            input.onchange = function () {
              var file = input.files[0];
              var reader = new FileReader();
              reader.onload = function (e) {
                callback(e.target.result, {
                  alt: file.name,
                });
              };
              reader.readAsDataURL(file);
            };
            console.log(value);
          }
        },
        toolbar_mode: "sliding",
        menubar: "file edit view insert format tools table tc help",
        toolbar:
          "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment",

        plugins: ["lists link image paste help wordcount"],
      },
    };
  },

  props: ["height", "value"],
  components: {
    editor: Editor,
  },
  methods: {
    updateValue() {
      console.log(this.editorContent);
      this.$emit("editor", this.editorContent);
    },
  },
  created() {},
};
</script>

<style>
</style>